import React, { useMemo, useState,useEffect } from "react";
import { useTable,useGlobalFilter,useSortBy,usePagination,useRowSelect,useExpanded,useFilters} from "react-table";
// import DummyData from "../../dummyData/confirmhistory.json";
import { confirmHistoryColumn } from "./Columns";
import { GlobleFilter,CheckBox } from "../../tableFilter";
// import {DiamDetail} from "../../popup/DiamDetail"
import { Collapse, Dropdown, Modal } from 'react-bootstrap';
// import {DiamDetail} from "../popup/DiamDetail"
import ExpandedDetailsNew from "../../expandedDetails/ExpandedDetailsNew"
import axios from 'axios';
import { BASE_URL, NODE_API_URL } from '../../../../env_config';
import { FaSortDown,FaSortUp,FaAngleLeft,FaAngleRight,FaAngleDoubleLeft,FaAngleDoubleRight,FaChevronDown, FaChevronRight,FaEllipsisV} from "react-icons/fa";
import ConfirmListSkeleton from "../../SkeletonLoaders/ConfirmList";
import PerfectScrollbar from "react-perfect-scrollbar";
import FilterComponent from "../../tableFilter/FilterComponent";
import { Logoutuser } from "../../controls/Logoutuser";
const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};

export const ConfirmList = ({userinfo,filterOpen,filters,setFilters}) => {
    // const [showDiamPopup,setShowDiamPopup] = useState(false)
    // const [showDiamData,setShowDiamData] = useState([])
    const [loader,setLoader] = useState(true)
    const [data,setData] = useState([])
    const [totalCarat,setCarat] = useState(0)
    const [totalPrice,setTotalPrice] = useState("00")
    const [totalLocalPrice,setTotalLocalPrice] = useState("00")
    const [totalPrCarat,setTotalPrCarat] = useState("00")
    const [totalLocalPrCarat,setTotalLocalPrCarat] = useState("00")
    const [CustomizeTable, setCustomizeTable] = useState(false);
    const handleClose = () => setCustomizeTable(false);
    const renderRowSubComponent = React.useCallback(
        (row) => (
            <>
                <ExpandedDetailsNew row={row.row.original} userinfo={userinfo} />
            </>
        ),[]
      )

    const columns = useMemo(() => confirmHistoryColumn(userinfo), [userinfo]);
    // const data = useMemo(() => DummyData, []);
    useEffect(() => {
       
        axios({
            method: "GET",
            url: `${NODE_API_URL}/SUPP/confirm-history`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("authToken")}`
              },
        }).then((res) => {
            setLoader(false)
            if (res && res.data && res.data.data) {
                setData(res.data.data)
            }
        }).catch((res) => {
            setLoader(false)
            if(res?.response?.data?.message === "UnAuthorized!"){
                Logoutuser();
            }
          });
    },[userinfo.supplierName])


    const globalFilterFunction = (rows, columnIds, filterValue) => {
        return rows.filter(row => {
            const values = Object.values(row.original); // Get all field values of the row
            return values.some(value => 
                String(value).toLowerCase().includes(filterValue?.toLowerCase())
            );
        });
    };

    const {
        getTableProps,
        getTableBodyProps,
        prepareRow,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        pageCount,
        visibleColumns, 
        setPageSize,
        setGlobalFilter,
        setFilter,
        allColumns,
        selectedFlatRows,
        getToggleHideAllColumnsProps,
        state: { globalFilter, pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            globalFilter: globalFilterFunction
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [
                    // {
                    //     Header: () => null,
                    //     id: "expander-popup",
                    //     Cell: ({ row }) => (
                    //         <span>
                    //             <FaEye className="text-hover-primary cursor-pointer" onClick={() => showDiamDetail(row)}/>
                    //         </span>
                    //     ),
                    // },
                    {
                        id:'selection',
                        Header:({ getToggleAllPageRowsSelectedProps }) =>(
                            <CheckBox title="Select" {...getToggleAllPageRowsSelectedProps()} />
                        ),
                        Cell: ({ row }) => (
                            <div>
                              <CheckBox title="Select" {...row.getToggleRowSelectedProps()} />
                            </div>
                          ),
                    },
                    {
                        Header: () => null,
                        id: 'expander',
                        Cell: ({ row }) => (
                            row.original.diamondType === "PN" || row.original.diamondType === "PL" ? null :
                            <span  {...row.getToggleRowExpandedProps()}>
                                {row.isExpanded ? <FaChevronDown className="text-success "  title="Collapse"/> :  <FaChevronRight className="text-primary" title="Expand" />}
                            </span>
                        ),
                    },
                    ...columns,
                ];
            });
        }
    );

    useEffect(() => {
        let tempTotalCarat = 0
        let tempTotalPrice = 0
        let tempTotalLocalPrice = 0

        selectedFlatRows.map(value => {
            tempTotalCarat += parseFloat(value.original.cWeight)
            tempTotalPrice += parseFloat(value.original.aPrice)
            tempTotalLocalPrice += parseFloat(value.original.aPrice * value.original.curInr)
        })
        setCarat(tempTotalCarat)
        setTotalPrice(tempTotalPrice)
        setTotalPrCarat(tempTotalPrice / tempTotalCarat)
        setTotalLocalPrice(tempTotalLocalPrice)
        setTotalLocalPrCarat(tempTotalLocalPrice / tempTotalCarat)
    },[selectedFlatRows])
    return (
        <>
            {!loader ? <div className="card-body p-0">
                <Collapse in={filterOpen}>
                    <div className="row mb-5">
                        <div className="col-12">
                            {/* Ensure columns and data are defined before rendering the FilterComponent */}
                            {columns && data && (
                                <FilterComponent columns={columns} data={data} filters={{ filters: filters, setFilters: setFilters, setFilter }} />
                            )}
                        </div>
                    </div>
                </Collapse>
                <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="font-weight-bolder font-size-h5 text-primary">
                        Confirm List
                        <div className="font-weight-bold font-size-sm text-muted">
                            <span className="text-primary">Total Diamonds: </span> {selectedFlatRows.length} <span className="text-dark px-2">|</span><span className="text-primary ml-2">Total Carat :</span>{totalCarat.toFixed(2)} <span className="text-dark px-2">|</span><span className="text-primary">Total Price :</span> ${Math.round(totalPrice*100)/100}  <span className="text-dark px-2">|</span><span className="text-primary">Total $/CT :</span> ${Math.round(totalPrCarat*100)/100 || "00"}  <span className="text-dark px-2">|</span><span className="text-primary">Total Local Price :</span> {Math.round(totalLocalPrice*100)/100}  <span className="text-dark px-2">|</span><spanc className="text-primary">Total Local per CT</spanc> : {Math.round(totalLocalPrCarat*100)/100 || "00"}
                        </div>
                    </div>
                    <div className="d-flex" style={{width:"200px"}}>
                        <GlobleFilter filter={globalFilter} setFilter={setGlobalFilter}  />
                        <div className="search_result_dropdown">
                            <Dropdown >
                                <Dropdown.Toggle size="sm" variant="clear">
                                    <FaEllipsisV />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => setCustomizeTable(true)}>Customize Table</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Modal
                                size="sm"
                                show={CustomizeTable}
                                onHide={() => setCustomizeTable(false)}
                                aria-labelledby="Customize-table"
                            >
                                <Modal.Header className="px-5 py-3" closeButton>
                                    <Modal.Title id="Customize-table">
                                        Customize Columns
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="p-2 searchResult">
                                    <PerfectScrollbar
                                        options={perfectScrollbarOptions}
                                        className="scroll"
                                        style={{ maxHeight: "400px", position: "relative" }}
                                    >
                                    {/* <div  className="" > */}
                                        <div>
                                            <label className="checkbox my-2 border p-2">
                                                <input type='checkbox' {...getToggleHideAllColumnsProps()}  />
                                                <span className="mr-2"></span>
                                                Show All
                                            </label> 
                                        </div>
                                        {
                                            allColumns.map(column =>(
                                                <div key={column.id} className={`${column.id}`}>
                                                    <label className="checkbox my-2 border p-2">
                                                        <input type='checkbox' {...column.getToggleHiddenProps()}  />
                                                        <span className="mr-2"></span>
                                                        {column.Header}
                                                    </label>
                                                </div>
                                            ))
                                        }
                                    {/* </div> */}
                                    </PerfectScrollbar>
                                </Modal.Body>
                                <Modal.Footer className="px-5 py-3">
                                    {/* <button type="button" className="btn btn-light mr-2 text-nowrap" onClick={handleClose}>Close</button> */}
                                    <button type="button" className="btn btn-primary mr-2 text-nowrap" onClick={handleClose}>Save Changes</button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
                <div className="table-responsive custom-scrollbar w-100 mt-4">
                    <table className="table table-striped table-hover custom_datatable" {...getTableProps()} >
                            <thead className="custom_datatable_head">
                            {headerGroups.map((headerGroup, i) => (
                                <tr key={i} {...headerGroup.getHeaderGroupProps()} >
                                    {headerGroup.headers.map(
                                        (column, i) => (
                                            <th key={i} className="text-center text-nowrap align-middle" {...column.getHeaderProps(column.getSortByToggleProps())}>
                                                {column.render("Header")}
                                                <span className="text-secondary">
                                                    {column.isSorted ? ( column.isSortedDesc ? ( <FaSortDown /> ) : ( <FaSortUp /> )) : ("")}
                                                </span>
                                            </th>
                                        )
                                    )}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {data.length !== 0 ? page.map((row) => {
                                prepareRow(row)
                                return(
                                    <React.Fragment key={row.id}>
                                        <tr {...row.getRowProps()} key={row.id} >
                                            {row.cells.map((cell,i) => {
                                                return <td  className="text-center align-middle" {...cell.getCellProps({ className: cell.column.className})} key={i}>{cell.render('Cell')}</td>
                                            })}
                                        </tr>
                                        {row.isExpanded ? (
                                            <tr>
                                                <td className="p-0" colSpan={visibleColumns.length}>
                                                    {renderRowSubComponent({ row })} 
                                                </td>
                                            </tr>
                                        ) : null}
                                    </React.Fragment>
                                )
                            }) :
                            <tr>
                                <td className="text-center align-middle"colSpan="100%">
                                    No data found
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <span className="table_page_length">
                        Page {pageIndex + 1} of {pageOptions.length}{" "}
                    </span>
                    <div>
                        <button className="btn btn-sm btn-light mr-2" onClick={() => gotoPage(0)} disabled={!canPreviousPage} >
                            <FaAngleDoubleLeft />
                        </button>
                        <button className="btn btn-sm btn-light mr-2" onClick={() => previousPage()} disabled={!canPreviousPage} >
                            <FaAngleLeft />
                        </button>
                        <span className="font-weight-bold text-muted">
                            <input
                                className="form-control d-inline-block form-control-sm"
                                type="number"
                                value={pageIndex + 1}
                                // defaultValue={pageIndex + 1}
                                onChange={(e) => {
                                    const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                                    gotoPage(pageNumber);
                                }}
                                style={{ maxWidth: "70px" }}
                            /> of {pageOptions.length} 
                        </span>
                        <button className="btn btn-sm btn-light mr-2" onClick={() => nextPage()} disabled={!canNextPage} >
                            <FaAngleRight />
                        </button>
                        <button className="btn btn-sm btn-light" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} >
                            <FaAngleDoubleRight />
                        </button>
                    </div>
                    <span className="d-flex align-items-center">
                        <span className="text-nowrap page_size">
                            Rows Per page:{" "}
                        </span>
                        <select
                            className="form-select ml-2 custom-select py-1"
                            value={pageSize}
                            onChange={(e) =>
                                setPageSize(Number(e.target.value))
                            }
                        >
                            {[10, 25, 50].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                </option>
                            ))}
                        </select>
                    </span>
                </div>
                {/* <DiamDetail show={showDiamPopup} onHide={() => setShowDiamPopup(false)} data={showDiamData}/> */}
            </div>
            : 
                <ConfirmListSkeleton />
                // <div className="card-body p-0 d-flex justify-content-center font-weight-bold font-size-lg">
                //     Loading...<div className="spinner spinner-primary ml-5"></div>
                // </div>
            }
        </>
    );
};
